/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import {Table , ButtonGroup , ListGroupItem , ListGroup , Alert , Button , FormControl , FormGroup ,  Navbar , NavDropdown , MenuItem , Nav , NavItem , Modal , Row , Col} from 'react-bootstrap';
import Card from './card.js';
import CardHeader from './card-header.js';
import CardBody from './card-body.js';
import ContentService from '../services/content-service.js';
import ContentStore from '../store/content-store.js';
import CDNImage from '../components/media/image.js';
import CDNAudio from '../classes/audio.js';
import { FormattedMessage } from 'react-intl';

export default class ContentCheckout  extends React.Component {

    constructor(props){
        super();

        this.CatalogParams = {catalogUID:props.catalogUID , learning:props.learning , support:props.support  };

        this.state = {
            vocabulary: [],
            catalog: ContentStore.getCatalog(props.catalogUID),
            summary: ContentStore.getCatalogSummary(props.catalogUID).summary
        }

    }

    componentWillMount() {

        ContentService.fetchCatalogSummary(this.CatalogParams.catalogUID , this.CatalogParams.learning , this.CatalogParams.support)
    }

    componentDidMount(){
        ContentStore.on('ON_VOCAB_FETCH'  , () => {

            this.setState({
                catalog:ContentStore.getCatalog(this.props.catalogUID)
            })

        })

        ContentStore.on('ON_SUMMARY_FETCH'  , () => {

            this.setState({
                summary:ContentStore.getCatalogSummary(this.CatalogParams.catalogUID).summary
            });

            var summary = ContentStore.getCatalogSummary(this.CatalogParams.catalogUID).summary;

            ContentService.fetchCatalog(this.CatalogParams.catalogUID , summary.learning_ietf , summary.support_ietf)
        });
    }

    componentWillReceiveProps(props){

        var newCatalogParams = {catalogUID:props.catalogUID , learning:props.learning , support:props.support  }

        if(JSON.stringify(this.CatalogParams) != JSON.stringify(newCatalogParams))
        {
            this.CatalogParams = newCatalogParams
            ContentService.fetchCatalog(this.CatalogParams.catalogUID , this.CatalogParams.learning , this.CatalogParams.support)
        }

    }

    playAudio(path){
        (new CDNAudio(path)).play();
    }

    removeVocab(uid){
        ContentService.removeVocab(this.CatalogParams.catalogUID , uid).then(function(){
            ContentService.fetchCatalog(this.CatalogParams.catalogUID);
            ContentService.fetchCatalogSummary(this.CatalogParams.catalogUID);
        }.bind(this));
    }

    goToSummary(){
        window.location.hash = 'builder/checkout/'+this.CatalogParams.catalogUID;
    }

    publishContent(){

        if(this.state.summary.state == "PUBLISHED")
        {
            ContentService.unPublish(this.CatalogParams.catalogUID).then(function(){
                window.location.hash = "/builder/overview";

            });
        }
        else
        {
            ContentService.publish(this.CatalogParams.catalogUID).then(function(){
                window.location.hash = "/builder/overview";
            });
        }
    }

    assignContent(){

        if(this.state.summary.state == "PUBLISHED")
        {
            window.location.hash = "/builder/assign/"+this.CatalogParams.catalogUID;
        }
        else
        {

            ContentService.publish(this.CatalogParams.catalogUID).then(function(){
                window.location.hash = "/builder/assign/"+this.CatalogParams.catalogUID;
            }.bind(this));
        }

    }

    render(){
        let Style={display:'table-cell'};

        if(!this.state.catalog) return null;
        if(!this.state.summary) return null;

        var VocabObjects = [];

        for(var idx = 0 ; idx < this.state.catalog.vocab.length; idx++)
        {
            let vocabObject = this.state.catalog.vocab[idx];
            VocabObjects.push(<ListGroupItem md={4}><Table className="p-0 b-0" >
                <tbody className="p-0 b-0">
                <tr className="p-0 b-0">
                    <td className="p-0 b-0">{vocabObject.word}</td>
                    <td  className="p-0 b-0" width={70}>


                    <Button width={20} className="p-5" onClick={this.playAudio.bind(this ,  vocabObject.learningAudio)} >
                        &nbsp;<i className="zmdi zmdi-volume-up"></i>&nbsp;
                    </Button>
                    &nbsp;&nbsp;
                    <Button onClick={this.removeVocab.bind(this , vocabObject.uid)} width={20} className="p-5" bsStyle="danger" >
                        <b>&nbsp;&nbsp;x&nbsp;&nbsp;</b>
                    </Button>
                </td>
                </tr>
                </tbody>
            </Table>

            </ListGroupItem>);
        }

        let warning = null;

        if(VocabObjects.length > 10)
        {
            warning = <Alert bsStyle="warning">
                        <FormattedMessage id={"ui-2217"} defaultMessage={"Unpublish"} />
                    </Alert>
        }

        if(VocabObjects.length < 8)
        {
            warning = <Alert bsStyle="warning">
                <FormattedMessage id={"ui-2218"} defaultMessage={"Unpublish"} />
            </Alert>
        }

        console.log("sdfobaefbwiefwiefbw8bveg");
        return <div>

            <Card>

                <CardHeader>
                    <h4>{this.state.summary.title}</h4>
                    <small>{this.state.summary.description}</small>
                    {warning}
                    <br />
                    <br />
                    <Button block onClick={this.goToSummary.bind(this)}><FormattedMessage id={"ui-2216"} defaultMessage={"Overview"} /></Button>
                </CardHeader>
                <CardBody>
                    <ListGroup>
                        {VocabObjects}
                    </ListGroup>
                    <br />
                    <br />
                    <Button disabled={VocabObjects.length < 8} onClick={this.publishContent.bind(this)} bsStyle="primary" block><b>{this.state.summary.state == "PUBLISHED" ? <FormattedMessage id={"ui-2213"} defaultMessage={"Unpublish"} />  : <FormattedMessage id={"ui-666"} defaultMessage={"Publish"} /> }</b></Button>
                    <Button disabled={VocabObjects.length < 8} onClick={this.assignContent.bind(this) } bsStyle="primary" block> {this.state.summary.state != "PUBLISHED" ? <FormattedMessage id={"ui-2214"} defaultMessage={"Publish & Assign"} /> : <FormattedMessage id={"ui-974"} defaultMessage={"Assign"} />}</Button>
                </CardBody>
            </Card>

        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/content-checkout.js